<template>
  <main>
    <div class="table-responsive wrapper">
      <table class="table" :id="`table_${sortType}`">
        <thead>
          <tr>
            <!-- col drag -->
            <th class="drag"></th>
            <!-- col task type -->
            <th class="type text-center">番号</th>
            <!-- col task name -->
            <th class="name">名前</th>
            <!-- col status -->
            <th class="status text-center">状態</th>
            <!-- col sort -->
            <th class="sort text-center">表示順</th>
            <!-- col add button -->
            <th class="control">
              <b-button
                size="sm"
                class="addButton d-flex align-items-center float-right"
                variant="link"
                @click="showAddModal"
              >
                <span class="material-icons material-icons-outlined">add</span>
                追加
              </b-button>
            </th>
          </tr>
        </thead>
        <draggable
          v-model="localData"
          tag="tbody"
          draggable=".data_flow"
          :move="onMoveColumnOrder"
          @end="onEndColumnOrder"
        >
          <tr
            class="data_flow"
            v-for="(data, index) in localData"
            :key="data.taskType"
            @mouseover="displayIconFilterAdDrag(index, true)"
            @mouseout="displayIconFilterAdDrag(index, false)"
          >
            <td class="drag-icon">
              <span
                :id="`isDrag_${sortType}_${index}`"
                class="icon_drag material-icons material-icons-outlined"
              >
                drag_indicator
              </span>
            </td>
            <td class="text-center font-weight-bold"><div>{{ data.taskType }}</div></td>
            <td class="align-middle"><span class="task-type-name">{{ data.taskTypeName }}</span></td>
            <td class="text-center"><div>{{ data.isEnabled === 1 ? '有効' : '無効' }}</div></td>
            <td class="text-center font-weight-bold"><div>{{ data.sortCount }}</div></td>
            <td>
              <span class="d-flex justify-content-end h-100">
                <b-button
                  size="sm"
                  class="deleteButton d-flex flex-row align-items-center"
                  variant="link"
                  @click="onDelete(data.taskType, data.sortingType)"
                  v-if="data.isDisplayButton && !data.isSample"
                >
                  <span class="material-icons material-icons-outlined">
                    delete
                  </span>
                  削除
                </b-button>
                <b-button
                  size="sm"
                  class="copyButton d-flex flex-row align-items-center"
                  variant="link"
                  @click="duplicationData(data)"
                >
                  <span class="material-icons material-icons-outlined">
                    content_copy
                  </span>
                  複製
                </b-button>
                <b-button
                  size="sm"
                  class="editButton d-flex flex-row align-items-center"
                  variant="link"
                  @click="showEditModal(data)"
                >
                  <span class="material-icons material-icons-outlined">
                    edit
                  </span>
                  編集
                </b-button>
              </span>
            </td>
          </tr>
        </draggable>
      </table>
    </div>
    <task-type-setting-modal
      :ref="`sorting-modal-${sortType}`"
      :id="sortType"
      @on-submit="onSubmit"
      :objectDefaultData="objectDefaultData"
      :pRejectChuteNo="pRejectChuteNo"
      :taskTypeData="tableData"
      :showManualSortSetting="showManualSortSetting"
      :enableMultiSortSetting="enableMultiSortSetting"
    />
    <delete-modal-component
      ref="confirmationDeleteModal"
      @on-delete="confirmDeleteTaskType"
    />
  </main>
</template>

<script>
import draggable from 'vuedraggable'
import FlashMessage from '../../common/flash-message.component'
import TaskTypeSettingModal from './TaskTypeSettingModal.vue'
import DeleteModalComponent from '../custom-components/DeleteModalComponent.vue'
const ADD_MODAL = 0
const EDIT_MODAL = 1
const CLONE_MODAL = 2
export default {
  components: {
    draggable,
    TaskTypeSettingModal,
    DeleteModalComponent
  },
  props: ['tableData', 'sortType', 'objectDefaultData', 'pRejectChuteNo', 'showManualSortSetting', 'enableMultiSortSetting'],
  data() {
    return {
      movingIndex: null,
      futureIndex: null,
      localData: [],
      isEnabledCount: 0,
      taskTypeId: null
    }
  },
  watch: {
    tableData(newVl, oldVl) {
      this.taskTypeId = null
      this.isEnabledCount = 0
      this.init()
      if (this.localData) {
        const filterTaskTypeIsEnabled = this.localData.filter(data => data.isEnabled === 1)
        if (filterTaskTypeIsEnabled.length === 1) {
          this.taskTypeId = filterTaskTypeIsEnabled[0].taskType
        }
        this.localData.forEach(el => {
          // Default value of isDisplayButton field for each line when loading data
          // will show delete and status buttons
          el['isDisplayButton'] = true
          // Update value of sortCount field when isEnabled = 1 and set value '-' when isEnabled = 0
          switch (el.isEnabled) {
            case 1:
              el['sortCount'] = el.sort - this.isEnabledCount
              break
            default:
              el['sortCount'] = '-'
              this.isEnabledCount++
              break
          }
          // When there is only 1 element in the data list or only 1 line with the value isEnabled = 1,
          // delete and status buttons will be hidden
          if (this.taskTypeId === el.taskType || this.localData.length === 1) {
            el['isDisplayButton'] = false
          }
        })
      }
    }

  },
  created() {
    this.init()
  },
  methods: {
    /**
     * handle check display icon filter and icon drag on header table
     */
    displayIconFilterAdDrag(index, isCheck) {
      let styleDrag = document.getElementById(
        `isDrag_${this.sortType}_${index}`
      ).style
      if (isCheck) styleDrag.visibility = 'visible'
      if (!isCheck) styleDrag.visibility = 'hidden'
    },
    checkToShowErrorMsgOnEditModal() {
      this.$refs[`sorting-modal-${this.sortType}`].checkToShowErrorMsgOnEditModal()
    },
    showAddModal() {
      this.$refs[`sorting-modal-${this.sortType}`].showModal(this.objectDefaultData, ADD_MODAL)
    },
    showEditModal(data) {
      this.$refs[`sorting-modal-${this.sortType}`].showModal(data, EDIT_MODAL)
    },
    duplicationData(data) {
      this.$refs[`sorting-modal-${this.sortType}`].showModal(data, CLONE_MODAL)
    },
    onSubmit(dataRequest, sortType, typeModal) {
      this.$emit('on-insertUpdate', dataRequest, { sortType, typeModal })
    },
    // sortTableData() {
    //   return this.tableData.sort((a, b) => a.sort - b.sort)
    // },
    async onDelete(taskType, sortingType) {
      let taskTypeIsDelete = this.localData.filter(data => data.taskType === taskType && data.sortingType === sortingType)
      this.$refs.confirmationDeleteModal.show(taskTypeIsDelete[0])
    },
    confirmDeleteTaskType(taskTypeIsDelete, removeConfirm, id) {
      this.$bvModal.hide(id)
      if (removeConfirm) {
        this.$emit('on-delete', taskTypeIsDelete.taskType, taskTypeIsDelete.sortingType)
      } else {
        FlashMessage.getInstance().showSuccessMessage(
          '削除をキャンセルしました。'
        )
      }
    },
    /**
     * Trigger drag column
     */
    onMoveColumnOrder(event) {
      const { index, futureIndex } = event.draggedContext
      this.movingIndex = index
      this.futureIndex = futureIndex
      return false // disable sort
    },
    /**
     * End dragging the column
     */
    async onEndColumnOrder(e) {
      if (this.movingIndex === null || this.futureIndex === null) {
        return
      }
      if (this.futureIndex === this.localData.length) {
        this.futureIndex = this.localData.length - 1
      }
      let originalOrder = this.localData[this.movingIndex].sort
      let targetOrder = this.localData[this.futureIndex].sort
      const isDragToBottom = originalOrder < targetOrder
      const increment = isDragToBottom ? -1 : 1

      if (isDragToBottom) {
        for (let i = this.movingIndex; i <= this.futureIndex; i++) {
          if (this.movingIndex === i) {
            this.localData[this.movingIndex].sort = targetOrder
          } else {
            this.localData[i].sort = this.localData[i].sort + increment
          }
        }
      } else {
        for (let j = this.futureIndex; j <= this.movingIndex; j++) {
          if (this.futureIndex === j || j !== this.movingIndex) {
            this.localData[j].sort = this.localData[j].sort + increment
          } else {
            this.localData[j].sort = targetOrder
          }
        }
      }
      this.localData.sort((a, b) => a.sort - b.sort)
      // TODO sort list
      let taskTypeList = []
      this.localData.forEach((el, index) => {
        taskTypeList.push({taskType: el.taskType, sort: el.sort})
      })
      this.movingIndex = null
      this.futureIndex = null
      this.$emit('on-update-sort', taskTypeList)
    },
    // swapLabelOrder(oldTableLabels, newTableLabels, isSmaller) {
    //   const oldOrder = oldTableLabels.sort
    //   const newOrder = newTableLabels.sort
    //   if (oldOrder !== newOrder) {
    //     oldTableLabels.sort = newOrder
    //     newTableLabels.sort = oldOrder
    //     return
    //   }
    //   if (isSmaller) {
    //     oldTableLabels.sort++
    //   } else {
    //     newTableLabels.sort++
    //   }
    // },
    init() {
      // When opening modal add still show status button
      this.objectDefaultData['isDisplayButton'] = true
      this.localData = [...this.tableData]
    },
    closeModalTaskType(isSuccess) {
      this.$refs[`sorting-modal-${this.sortType}`].updateIsCloseModal(isSuccess)
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin styleActionButtons($property, $color, $marginRight: 16px) {
  @include responsive-fs(12);
  margin: 0;
  margin-right: $marginRight;
  padding: 0;
  color: $color;
  text-decoration: none;
  #{$property} {
    @include responsive-fs(14);
    margin-bottom: 1px;
  }
  &:last-child {
    margin-right: 0;
  }
}
.wrapper {
  padding: 0;
  margin-bottom: 0px !important;
  overflow-y: auto;
  max-height: 500px;
  .table {
    border-collapse: separate;
    border-spacing: 0;
    table-layout: auto;
    th {
      @include responsive-fs(12);
      white-space: nowrap;
      border-bottom: 2px solid #dee2e6;
      &.drag {
        width: 50px;
      }
      &.type {
        width: 80px;
      }
    }
    tr:first-child {
      td {
        @media only screen and (min-width: 1921px) {
          border-top: 1px solid #dee2e6;
        }
      }
    }
    .drag-icon {
      vertical-align: middle;
    }
    td {
      @include responsive-fs(18);
      height: 56px;
      border-bottom: 1px solid #dee2e6;
      white-space: nowrap;
      div {
        justify-content: center;
        display: flex;
        height: 100%;
        align-items: center;
      }
      .task-type-name {
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        white-space: normal;
        // Addition lines for 2 line or multiline ellipsis
        display: -webkit-box !important;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    tbody tr:hover {
      background: rgba(78, 102, 166, 0.08);
      cursor: pointer;
    }
    thead tr th,
    tbody tr td {
      border-top: none;
    }
    thead {
      position: sticky;
      top: 0;
      z-index: 1;
      background: #ffff;
    }
    .addButton {
      @include styleActionButtons(span, #4e66a6, 0);
    }
    .deleteButton {
      @include styleActionButtons(span, #666563);
    }
    .copyButton {
      @include styleActionButtons(span, #4e66a6);
    }
    .editButton {
      @include styleActionButtons(span, #4e66a6);
    }
  }
  .icon_drag {
    display: flex;
    @include responsive-fs(25);
    color: #8a8988;
    visibility: hidden;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/task-type-setting/TaskTypeSettingTable.vue